(function () {
  const CALC_SELECTOR = '[id*="option_calculator_product_option"]';

  // Exact strings the app currently renders, mapped to their translation.
  // Only need entries for locales where the app's own text is wrong.
  const DICTIONARY = {
    en: {
      'VOLGENDE': 'NEXT',
      'TERUG': 'BACK',
      'width (cm) *': 'width (cm)',
      'height (cm) *': 'height (cm)',
      'enkele plooi': 'single pleat',
      'wave plooi': 'wave pleat',
      'twee delen': 'two parts',
      'linker deel': 'left part',
      'rechter deel': 'right part',
      'Wat zijn de afmetingen?': 'What are the dimensions?',
      'Welke afwerking wil je?': 'Which finish do you want?',
      'Wil je het gordijn in één of twee delen?': 'Do you want the curtain in one or two parts?',
      'Voor welk raam is dit gordijn?': 'Which window is this curtain for?',
      'IN WINKELWAGEN': 'ADD TO CART',
    },
    nl: {
      'pleat *': 'vouw *',
      'one or two parts *': 'één of twee delen *',
      'breedte (cm) *': 'breedte (cm)',
      'hoogte (cm) *': 'hoogte (cm)',
    },
  };

  function currentLocale() {
    if (window.langify && langify.locale && langify.locale.iso_code) {
      return langify.locale.iso_code;
    }
    return (window.Shopify && Shopify.locale) || 'en';
  }

  function translateNode(node, dict) {
    if (node.nodeType === Node.TEXT_NODE) {
      const trimmed = node.textContent.trim();
      if (dict[trimmed]) node.textContent = node.textContent.replace(trimmed, dict[trimmed]);
      return;
    }
    node.childNodes.forEach((child) => translateNode(child, dict));
  }

  function watchCalculator(root) {
    const dict = DICTIONARY[currentLocale()];
    if (!dict) return;

    translateNode(root, dict);

    const observer = new MutationObserver(() => translateNode(root, dict));
    observer.observe(root, { childList: true, subtree: true, characterData: true });
  }

  function init() {
    document.querySelectorAll(CALC_SELECTOR).forEach(watchCalculator);
  }

  document.readyState === 'loading'
    ? document.addEventListener('DOMContentLoaded', init)
    : init();
}());